import Vue, { VueConstructor } from 'vue';
import router from '@/router';
import VueGtag from 'vue-gtag';
import { Route } from 'vue-router';

const AnalyticsDimensions = {
  dimension1: 'userType'
} as const;
type DimensionsIndex = keyof typeof AnalyticsDimensions;

const AnalyticsMetrics = {
} as const;
type MetricsIndex = keyof typeof AnalyticsMetrics;

export const Analytics = {
  setUserProperties (data: { [key: string]: number | boolean | string }): void {
    Vue.prototype.$gtag.set('user_properties', data);
  },
  sendDimension: function sendDimension<Key extends typeof AnalyticsDimensions[DimensionsIndex]> (key: Key, value: string): void {
    const data: any = {};
    data[key] = value;
    Vue.prototype.$gtag.event('send_dimension', data);
  },
  sendMetric: function sendMetric<Key extends typeof AnalyticsMetrics[MetricsIndex]> (key: Key, value: string): void {
    const data: any = {};
    data[key] = value;
    Vue.prototype.$gtag.event('send_metric', data);
  },
  install (Vue: VueConstructor): void {
    Vue.use(VueGtag, {
      enabled: window.PROPERTIES.has('google.analytics.id'),
      config: {
        id: window.PROPERTIES.get('google.analytics.id')
      },
      pageTrackerTemplate (to: Route) {
        const title = to.matched.reduce((t, i) => i.meta?.title || t, null) || to.name;
        return {
          page_title: title,
          page_path: to.path
        };
      }
    }, router);

    Vue.prototype.$gtag.customMap(Object.assign({}, AnalyticsDimensions, AnalyticsMetrics));
  }
};
